<!-- 工作台 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div class="pay-ctn">
      <el-form ref="form" :model="formData" label-width="80px">
        <el-form-item label="版本:">
          <div class="choose-ctn">
            <div
              :key="index"
              class="choose-item"
              :class="{'choose-item-active':item.Id == versionData.Id}"
              v-for="(item,index) in versionList"
              @click="toggleVersion(index)"
            >{{item.SetTitle}}</div>
          </div>
        </el-form-item>
        <el-form-item label="授权期限:">
          <div class="choose-ctn">
            <div
              :key="index"
              class="choose-item"
              :class="{'choose-item-active':item.Id == timeChosen.Id}"
              v-for="(item,index) in timeLimit"
              @click="toggleTime(index)"
            >{{item.ValidTime}}</div>
          </div>
        </el-form-item>
        <el-form-item label="您的选择:">
          <span>{{yourChosen}}</span>
          <p class="cValidTime" v-if="needConvert">
            <i class="el-icon-info"></i>
            剩余到期时间将会折算成新套餐有效时间为：{{cValidTime}}
          </p>
        </el-form-item>
        <el-form-item label="所需费用:">
          <div v-if="timeChosen.Promotions">
            <span class="goods-price">￥{{timeChosen.Promotions.DiscountPrice}}</span>
            <span class="original-price">￥{{timeChosen.Price}}</span>
          </div>
          <div v-else class="goods-price">￥{{timeChosen.Price}}</div>
        </el-form-item>
        <el-form-item label="支付方式:">
          <el-radio-group v-model="formData.payType" style="width: 500px;display: flex">
            <el-radio label="1" title="支付宝" class="radio-item">
              <img src="../../../assets/images/alipay.png" alt="" class="pay-icon">
            </el-radio>
            <el-radio label="2" title="微信支付" class="radio-item">
              <img src="../../../assets/images/wechatPay.png" alt="" class="pay-icon">
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="formData.agree"></el-checkbox>
          <span @click="agreeVisible=true" style="color: #409eff;cursor: pointer">同意产品服务协议</span>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" :class="{'btnDisable':!isCanPay}" @click="gotoPay" :disabled="!isCanPay">立即提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px">
      <div class="dialog-content">
        <div class="dialog-content-dir">
          <p>请在第三方支付页面完成付款</p>
          <p>付款完成前请不要关闭此窗口</p>
        </div>
        <div style="text-align: right">
          <el-button class="pay-btn btn-primary" @click="gotoShopOrder">我已付款成功</el-button>
          <el-button class="pay-btn" @click="reLoadPage" style="width: 200px">付款遇到问题重新支付</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="车回佳-商家入驻合作协议"
      :visible.sync="agreeVisible"
      width="850px"
    >
      <agree></agree>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
import agree from "../../registered/agree";
export default {
  mixins: [mixin],
  name: "",
  components: {
    agree,
    breadcrumb
  },
  data() {
    return {
      userMsg: this.$util.getLocalStorage("userMsg"),
      agreeVisible: false,
      dialogVisible: false,
      versionList: [], // 版本列表
      versionData: {}, // 选中版本
      timeLimit: [], // 期限列表
      timeChosen: {},
      versionId: "",
      formData: {
        payType: "1",
        agree: true
      },
      isCanPay: false,
      buyRecord: { PriorityLevel: 0 }, //用户套餐购买记录
      needConvert: false, //是否需要折算有效时间
      cValidTime: "" //折算后的授权期限
    };
  },
  mounted() {
    this.versionId = this.$route.query.id;
    this.getData();
  },
  computed: {
    yourChosen() {
      return this.versionData.SetTitle + this.timeChosen.ValidTime;
    }
  },
  methods: {
    reLoadPage() {
      window.location.reload();
    },
    gotoShopOrder() {
      this.$router.push(`/softwarePackage`);
    },
    gotoPay() {
      if (!this.userMsg) {
        this.$util.warningMsg("请登录");
        return;
      }
      if (this.formData.agree) {
        if (this.formData.payType == 1) {
          this.$util
            .axiosPost({
              url: `/api/SoftwareSets/AliPayRequest?vId=${
                this.timeChosen.Id
              }&uid=${this.userMsg.EmployeeId}`
            })
            .then(res => {
              this.dialogVisible = true;
              window.open(res.data);
            })
            .catch(() => {});
        } else {
          let price = this.timeChosen.Promotions
            ? this.timeChosen.Promotions.DiscountPrice
            : this.timeChosen.Price;
          this.$router.push(
            `/softwarePackage/softwarePayWeChat?vId=${
              this.timeChosen.Id
            }&price=${price}&versionId=${this.versionId}`
          );
        }
      } else {
        this.$util.warningMsg("请先阅读并同意我们的协议");
      }
    },
    toggleVersion(index) {
      this.versionData = this.versionList[index];
      this.timeLimit = this.versionList[index].Configs;
      this.timeChosen = this.timeLimit[this.timeLimit.length - 1];
      this.fnComputeCValidTime();
    },
    toggleTime(index) {
      this.timeChosen = this.timeLimit[index];
      this.fnComputeCValidTime();
    },
    //计算是否需要折算有效时间，是否可以购买，真能低升高或同级续费，不可降级
    fnComputeCValidTime() {
      this.needConvert = false;
      this.cValidTime = "";
      if (this.versionData.PriorityLevel > this.buyRecord.PriorityLevel) {
        if (this.timeChosen.ValidTimeNum > 0) {
          let dateBegin = new Date();
          let dateEnd = new Date(this.buyRecord.ExpireDate); //获取当前时间
          let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
          let dayDiff = Math.ceil(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
          if (dayDiff >= 1) {
            //旧套餐有效时间由月份转换为天数，每月30天，每年365天
            let validDay =
              parseInt(this.buyRecord.ValidTime / 12) * 365 +
              (this.buyRecord.ValidTime % 12) * 30;
            let surplusMoney = (this.buyRecord.Price / validDay) * dayDiff;

            //新套餐有效时间由月份转换为天数，每月30天，每年365天
            validDay =
              parseInt(this.timeChosen.ValidTimeNum / 12) * 365 +
              (this.timeChosen.ValidTimeNum % 12) * 30;
            //计算得出折算后的时间
            let price = this.timeChosen.Price;
            if (this.timeChosen.Promotions) {
              price = this.timeChosen.Promotions.DiscountPrice;
            }
            let CommutedTime = Math.ceil((surplusMoney * validDay) / price);
            //不足一天按一天算
            if (CommutedTime < 1) CommutedTime = 1;

            this.cValidTime = CommutedTime + "天";
            this.needConvert = true;
          }
        }

        this.isCanPay = true;
      } else if (
        this.versionData.PriorityLevel == this.buyRecord.PriorityLevel
      ) {
        this.isCanPay = true;
      } else {
        this.isCanPay = false;
      }
    },
    getData() {
      this.$util
        .axiosGet({
          url: "/api/SoftwareSets/GetSoftwareSetsList",
          data: {
            EntpId: this.userMsg.EntpId,
            EntpType: this.userMsg.EntpType
          }
        })
        .then(res => {
          let list = res.data.list;
          if (res.data.buyRecord) {
            this.buyRecord = res.data.buyRecord;
          }

          // list.splice(0, 1);
          this.versionList = list;
          for (let i = 0; i < list.length; i++) {
            if (list[i].Id == this.versionId) {
              this.versionData = list[i];
              this.timeLimit = list[i].Configs;
            }
          }
          this.timeChosen = this.timeLimit[this.timeLimit.length - 1];
          this.fnComputeCValidTime();
        });
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-content-dir {
  padding-left: 50px;
  margin-bottom: 20px;
  font-size: @font-sm;
  line-height: 2em;
}
.goods-price {
  color: red;
  font-size: @font-lg;
}
.original-price {
  font-size: @font-sm;
  margin-left: 10px;
}
.pay-ctn {
  width: 900px;
  margin: 0 auto;
  padding-top: 30px;
}
.choose-ctn {
  display: flex;
}
.choose-item {
  cursor: pointer;
  width: 150px;
  line-height: 40px;
  text-align: center;
  border: 1px solid @border3Color;
  margin-right: 20px;
}
.choose-item-active {
  border: 1px solid @theme;
  color: @theme;
}
.pay-icon {
  width: 30px;
  height: auto;
}
.radio-item {
  display: flex;
  align-items: center;
}
.cValidTime {
  color: red;
  margin-top: -15px;
}
.btnDisable {
  background-color: #c0c4cc;
  border-color: #c0c4cc;
}
.btnDisable:hover{
   background-color: #c0c4cc;
  border-color: #c0c4cc;
}
</style>
